// Filename - App.js

import React from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,

} from "react-router-dom";
import Leaderboard from "./apps/Leaderboard";
import Monitor from "./apps/Monitor";

const PlainHtmlElement = () => {
  return (
    <html>
      <head>
        <title>Griffith</title>
        <style>
          {`
              body {
              background-color: black;
              color: #32CD32;
              font-family: 'Courier New', monospace;
              font-size: 16px;
              white-space: pre-wrap;
              }
          `}
        </style>
      </head>
      <body>
        <pre>
          {
            `  GGGG         iii      dd                                        XX    XX    LL      LL      MM    MM
GG  GG rr rr           dd  sss  pp pp     aa aa   cccc   eee      XX  XX     LL      LL      MMM  MMM
GG      rrr  r iii  dddddd s     ppp  pp  aa aaa cc     ee   e      XXXX      LL      LL      MM MM MM
GG   GG rr     iii dd   dd  sss  pppppp  aa  aaa cc     eeeee      XX  XX     LL      LL      MM    MM
GGGGGG rr     iii  dddddd     s pp       aaa aa  ccccc  eeeee    XX    XX    LLLLLLL LLLLLLL MM    MM
                          sss  pp`
          }
        </pre>
      </body>
    </html>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PlainHtmlElement />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/monitor" element={<Monitor />} />
      </Routes>
    </Router>
  );
}

export default App;
